import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["userInfo"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import FilePickerPanel from 'file-manager-components/picker/FilePickerPanel';
import FileManager from './FileManager';
import { jsx as _jsx } from "react/jsx-runtime";
class FilePicker extends Component {
  render() {
    const _this$props = this.props,
      {
        userInfo
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(FileManager, {
      auth: userInfo,
      children: /*#__PURE__*/_jsx(FilePickerPanel, Object.assign({}, rest))
    });
  }
}
FilePicker.propTypes = {
  userInfo: PropTypes.object.isRequired
};
export default FilePicker;